import { MutationFunction } from '@apollo/client';
import { isNil } from '@sixfold/typed-primitives';
import React from 'react';

import { FeatureFlagsView } from '../../components/feature_flag';
import {
  CompanyWithFeatureFlagMetadataQuery,
  UpdateCompanyFeatureFlagMutation,
  UpdateCompanyFeatureFlagMutationVariables,
  getNodes,
} from '../../lib/graphql';
import { filterBackofficeCompanyFeatureFlagMetadata } from '../vehicle_history_feature_flags';

type CompanyFeatureFlags = {
  onFlagsChange: MutationFunction<UpdateCompanyFeatureFlagMutation, UpdateCompanyFeatureFlagMutationVariables>;
  currentSetFlags: Record<string, boolean>;
  loadMoreAuditLogs: () => Promise<unknown> | undefined;
  company?: CompanyWithFeatureFlagMetadataQuery['company'];
  allFlags?: CompanyWithFeatureFlagMetadataQuery['featureFlagMetadata'] | null;
  onlyFlagIds?: readonly string[];
};

export const CompanyFeatureFlags: React.FunctionComponent<CompanyFeatureFlags> = ({
  allFlags,
  onFlagsChange,
  currentSetFlags,
  company,
  loadMoreAuditLogs,
  onlyFlagIds,
}) => {
  if (isNil(allFlags)) {
    return null;
  }

  if (isNil(company)) {
    return null;
  }

  const isShown = (flagId: string | null) => isNil(onlyFlagIds) || (!isNil(flagId) && onlyFlagIds.includes(flagId));
  const auditLog = (getNodes(company.featureFlagAuditLogConnection) ?? []).filter(({ featureFlagId }) =>
    isShown(featureFlagId),
  );
  const visibleFlags = filterBackofficeCompanyFeatureFlagMetadata(allFlags).filter(({ feature_flag_id }) =>
    isShown(feature_flag_id),
  );

  return (
    <FeatureFlagsView
      allFlags={visibleFlags}
      auditLog={auditLog}
      loadMoreAuditLogs={loadMoreAuditLogs}
      onFlagsChange={onFlagsChange}
      companyId={company.company_id}
      currentSetFlags={currentSetFlags}
    />
  );
};
